// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const chartData = createReducer({}, on(setChartData, (state, action) => {
    return action.chartData;
}));
